import { observer } from "mobx-react-lite";
import React, { useContext, useEffect, useRef, useState } from "react";
import { RootStoreContext } from "../../app/stores/rootStore";
import { Form as FinalForm, Field } from "react-final-form";
import { FORM_ERROR } from "final-form";
import { translationHookOptions } from "../../app/localization/localization";
// reactstrap components
import {
  Button,
  Card,
  Row,
  Col,
  TabContent,
  TabPane,
  Form,
  FormGroup,
} from "reactstrap";
import InfoMessage from "../common/InfoMessage";
import TextInput from "../common/TextInput";
import Loader from "../common/Loader";
import LoaderModal from "../common/LoaderModal";
import { PresentationDetailsFormValues, PresentationLanguagesFormValues } from "../../app/models/repositoryUser";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import CustomFileField from "../common/CustomFileField";


const PresentationForm: React.FC=() => {

  const rootStore = useContext(RootStoreContext);
  const {
      loadingLanguages,
      loadLanguages,
      allLanguages,
    } = rootStore.commonStore;
  const { theme } = rootStore.commonStore;
  const [activeTab, setActiveTab] = useState("1");
  const [t] = useTranslation(["features"], translationHookOptions);
  const [isModalLoader, setIsModalLoader] = useState(false);
  const { closeShowPresentationModal} = rootStore.playerStore;
  const{  
      addPresentation,
      presentationDetails,
      presentationDetail
  }= rootStore.presentationStore
  const [formValues, setFormValues] = useState(new PresentationDetailsFormValues());
  const inputRef = useRef<HTMLInputElement | null>(null);
useEffect(() => {
  if (!allLanguages || allLanguages.length === 0) {
      loadLanguages().then().catch();
  }
presentationDetail(0).then(
      (dto) => {
      let presentationForm = new PresentationDetailsFormValues({
          languages: dto.languages,
          mainLanguageId:"1",
           selectedLanguages:[],
           presentationLanguages:[],
           id:0
      });
          dto.presentation.presentationLanguages.forEach((p)=>{
              presentationForm.selectedLanguages.push(p.languageId)
              presentationForm.presentationLanguages.push(
                  new PresentationLanguagesFormValues({
                      id:0,
                      languageId:p.languageId,
                      title:p.title,
                      isMain:p.isMain
                  })
              )
          })
  setFormValues(presentationForm);
      }
  ).catch();
    
  return () => {
     
  }
}, [loadLanguages,presentationDetails])

if (loadingLanguages ) return <Loader />;


 return(<> 
  
  <FinalForm
   mutators={{
    setTitle: (args, state, utils) => {
      const index = args[0];
      const filename = args[1];
      if (filename) {
        const titleField = state.fields[`presentationLanguages[${index}].title`];
        if (titleField && titleField.lastFieldState && (titleField.lastFieldState.value === "" || titleField.lastFieldState.value === undefined)) {
          titleField.change(filename.substr(0, filename.lastIndexOf(".")));
        }
      }
    },
  }}
  initialValues={formValues}
  onSubmit={(values : PresentationDetailsFormValues)=>{
      let formToSend= new PresentationDetailsFormValues({
          languages:values.languages,
          mainLanguageId:values.mainLanguageId,
          selectedLanguages:[],
          presentationLanguages:[],
           id:values.id
      });
      values.presentationLanguages.forEach(
          (lts:any)=>{
      if (values.selectedLanguages.includes(lts.languageId)) {
          formToSend.presentationLanguages.push(lts);
          formToSend.selectedLanguages.push(lts.languageId);
          }
      })
        // aggiungo una nuova presentazione
        setIsModalLoader(true);
       addPresentation(0, values,false)
        .then(
          (dto)=>{   
            setIsModalLoader(false);
            closeShowPresentationModal();
          }
      ).catch((error) => ({
          [FORM_ERROR]: error,
        }));
            
  }}
  validate={(values)=>{
      let errors = {};
      let errorNum = 0;

      if (
        !values ||
        values.presentationLanguages.length === 0 ||
        !values.presentationLanguages.some((x) => x.title)
        ) {
          errorNum++;
        }

      if (errorNum === 0) return errors;
      else return { count: errorNum };
  }}
  render={
      ({
          handleSubmit,
          invalid,
          pristine,
          values,
          form
        }) => (
          <Form onSubmit={handleSubmit} fluid="true">
           <Row>
            <Col sm={12}>
         <TabContent activeTab={activeTab} style={{marginTop:"-5vh"}} >
                {values.selectedLanguages.length === 0 && (
                  <InfoMessage
                    color="primary"
                    message="Non ci sono lingue impostate"
                    icon="fas fa-globe fa-3x"
                  />
                )}
                {values.selectedLanguages &&
                  values.selectedLanguages.map((l, index) => (
                    <TabPane
                      key={l}
                      tabId={l.toString()}
                    >
                       <Row>
                        <Col sm={12}>
                        <Field
                              name={`presentationLanguages[${
                                  values.presentationLanguages.findIndex(
                                    (x) => x.languageId === l
                                  ) > -1
                                    ? values.presentationLanguages.findIndex(
                                        (x) => x.languageId === l
                                      )
                                    : values.presentationLanguages.length
                                }].languageId`}
                              component={TextInput}
                              placeholder="Nome"
                              type="hidden"
                              className="form-control-alternative"
                              autoComplete="off"
                              defaultValue={l}
                            />
                            <Row>
                              <Col sm={12}>
                                <FormGroup>
                                  <label
                                    className="form-control-label"
                                    htmlFor={`presentationLanguages[${
                                      values.presentationLanguages.findIndex(
                                        (x) => x.languageId === l
                                      ) > -1
                                        ? values.presentationLanguages.findIndex(
                                            (x) => x.languageId === l
                                          )
                                        : values.presentationLanguages.length
                                    }].title`}
                                  >
                                  { t("presentation_name")}
                                  </label>
                                  <Field
                                    name={`presentationLanguages[${
                                      values.presentationLanguages.findIndex(
                                        (x) => x.languageId === l
                                      ) > -1
                                        ? values.presentationLanguages.findIndex(
                                            (x) => x.languageId === l
                                          )
                                        : values.presentationLanguages.length
                                    }].title`}
                                    component={TextInput}
                                    type="text"
                                    className="form-control-alternative"
                                    autoComplete="off"
                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                           <Row>
                                <Col sm={12} xs={12}>
                                     <FormGroup>
                                       <label
                                         className="form-control-label"
                                         htmlFor={`presentationLanguages[${
                                           values.presentationLanguages.findIndex(
                                             (x) => x.languageId === l
                                           ) > -1
                                             ? values.presentationLanguages.findIndex(
                                                 (x) => x.languageId === l
                                               )
                                             : values.presentationLanguages.length
                                         }].attachedFiles`}
                                       >
                                      { t("attachment_presentation")}  
                                       </label>
                                     <CustomFileField
                                     enabledUploadedListFile={true}
                                      multiple={true}
                                         name={`presentationLanguages[${
                                           values.presentationLanguages.findIndex(
                                             (x) => x.languageId === l
                                           ) > -1
                                             ? values.presentationLanguages.findIndex(
                                                 (x) => x.languageId === l
                                               )
                                             : values.presentationLanguages.length
                                         }].attachedFiles`}
                                         accept=".jpg,.jpeg,.png,.gif,.pdf,.ppt,.pptx,.mp4,.doc,.docx,.xls,.xlsx"
                                         setTitle={{ index : 
                                          values.presentationLanguages.findIndex(
                                          (x) => x.languageId === l
                                        ) > -1? values.presentationLanguages.findIndex(
                                              (x) => x.languageId === l)
                                          : values.presentationLanguages.length, mutator : form.mutators.setTitle}}
                                       />
                                     
                                     </FormGroup>
                                   </Col>
                                 </Row>
                            </Col>
                      </Row>
                    </TabPane>
                  ))}
              </TabContent>
            </Col>
          </Row>
          <Row>
            <Col>
              <Button
                disabled={invalid || pristine}
                //className="my-1"
                className={classNames(
                  "genericButton",
                  `${theme!.buttonColor} ${theme!.buttonBorderColor} ${
                    theme!.buttonTextColor
                  }`
                )}
                type="submit"
              >
                { t("save")}  
              </Button>
            </Col>
          </Row>
        </Form>
        )
  }
  >
</FinalForm>

<LoaderModal
      size="sm"
      title=""
      message={t("waiting",{ns:"features"})}
      isOpen={isModalLoader}
      toggle={() => {}}
    />
  </>)
}

export default observer(PresentationForm);
